const e=2e3,o=3,t=10,c=1e3,n=2e3,p=20;export{t as CARDS_LIMIT_INSTAGRAM,o as CHOICES_LIMIT_INSTAGRAM,p as CHOICE_LABEL_DISPLAY_LIMIT_INSTAGRAM,n as CHOICE_TITLE_LIMIT_INSTAGRAM,c as LOCATION_TITLE_LIMIT_INSTAGRAM,e as TEXT_LIMIT_INSTAGRAM};
//# sourceMappingURL=fieldLimitationsInstagram.js.map
